export default __webpack_public_path__ + "static/media/lb.8cb787e4.svg";